module.exports = __webpack_public_path__ + "img/dashboard-icon-white.b6238097.svg";